// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"231":"blueprint-icons-split-paths-by-size-loader","824":"blueprint-icons-all-paths-loader"}[chunkId] || chunkId) + "." + {"231":"1abaf9d1","248":"adbd5290","715":"d79d1cfe","824":"db3a5105","902":"48ad05d7"}[chunkId] + ".chunk.js";
};